export class HitUtils {
  /**
   * Converts the given string in camel case to kebab-case (abCd -> ab-cd)
   */
  static camelToKebab(camel) {
    return camel.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
  }

  /**
   * Converts the given string in camel case to snake_case (abCd -> ab_cd)
   */
  static camelToSnake(camel) {
    return camel.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();
  }

  /**
   * Converts the given kebab case to snake case (aB-Cd -> ab_cd)
   */
  static kebabToSnake(kebab) {
    return kebab.toLowerCase().replaceAll('-', '_');
  }

  /**
   * Converts the given snake case to kebab case (ab_cd -> ab-cd)
   */
  static snakeToKebab(snake) {
    return snake.toLowerCase().replaceAll('_', '-');
  }

  /** Converts the given snake case to camel case (ab_cd -> abCd) */
  static snakeToCamel(snake) {
    return snake.replace(/_([a-z])/g, (_, c) => c.toUpperCase());
  }

  /** Converts the given snake case to PascalCase (ab_cd -> AbCd) */
  static snakeToPascal(snake) {
    return (
      HitUtils.snakeToCamel(snake).charAt(0).toUpperCase() +
      HitUtils.snakeToCamel(snake).slice(1)
    );
  }

  /**
   * Generates a random number with the specified number of digits
   */
  static randomNo(digits) {
    const min = Math.pow(10, digits - 1);
    const max = Math.pow(10, digits) - 1;
    return Math.floor(min + Math.random() * (max - min + 1));
  }

  /**
   * Generates the designation for the standard entities. THe designations is
   * the concatenation of no and designations separated by a -. If a part does
   * not exist, the - is removed.
   */
  static createStandardDesignation(
    record,
    noKey = 'number',
    desKey = 'designation',
    separator = ' - '
  ) {
    if (!record) return null;
    return [record?.[noKey], record?.[desKey]]
      .filter((p) => p && p !== '' && p != 'undefined')
      .join(separator);
  }

  static filtersToString(filtersObject) {
    const stringifyFilters = {};
    Object.entries(filtersObject)
      .filter(([_, value]) => value.length > 0)
      .forEach(([key, values]) => {
        if (values.length === 0) return;
        let queryString = '';
        if (typeof values === 'string') {
          stringifyFilters[key] = values;
        } else {
          values.forEach((val) => {
            queryString += `${val},`;
          });
          const filterParts = key.split(/[.:]/);
          if (
            ['or', 'and'].some((item) => filterParts.includes(item)) &&
            !queryString.startsWith('(')
          ) {
            stringifyFilters[key] = `(${queryString.slice(0, -1)})`;
          } else {
            stringifyFilters[key] = `${queryString.slice(0, -1)}`;
          }
        }
      });
    return stringifyFilters;
  }

  static fullLocationString(item) {
    const parts = [];
    if (item.street) parts.push(item.street + ' ' + (item?.houseNo || ''));
    if (item.postcode || item.city)
      parts.push((item?.postcode || '') + ' ' + (item?.city || ''));
    if (parts.length > 0) {
      return parts.join('\n');
    }
    return null;
  }

  static convertFileSize(sizeInKb) {
    if (sizeInKb < 1000) {
      return sizeInKb + ' B';
    } else if (sizeInKb < 1000000) {
      return (sizeInKb / 1000).toFixed(2) + ' kB';
    } else if (sizeInKb < 1000000000) {
      return (sizeInKb / 1000000).toFixed(2) + ' MB';
    } else if (sizeInKb < 1000000000000) {
      return (sizeInKb / 1000000000).toFixed(2) + ' GB';
    }
  }

  /**
   * Splits the entire array into chunks of the given size
   */
  static chunkItems(arrayItems, chunkSize) {
    const chunks = [];
    for (let i = 0; i < arrayItems.length; i += chunkSize) {
      chunks.push(arrayItems.slice(i, i + chunkSize));
    }
    return chunks;
  }

  /**
   * Checks if the fileending is jpg, jpeg or png
   */
  static isImage(fileName) {
    return /\.(jpg|jpeg|png)$/i.test(fileName);
  }
}
